<template>
  <page-wrapper title="Sap Fi Report">
    <div class="page-container">
      <div class="row" style="padding-left: 35px">
        <div class="query-box">
          <div class="label col-5">วันที่ส่งไป SAP</div>
          <date-picker v-model="sentToSapDate" type="daterange"></date-picker>
        </div>
        <div class="query-box">
          <div class="label col-12">วันที่ในใบเสร็จรับเงิน</div>
          <date-picker
            v-model="receiptDateRange"
            type="daterange"
          ></date-picker>
        </div>
        <div class="query-box">
          <div class="label col-12">วันที่ในใบกำกับภาษี (เฉพาะ 17-18)</div>
          <date-picker v-model="taxInvoiceDate" type="daterange"></date-picker>
        </div>
        <div class="query-box">
          <div class="label col-12">Business Event No. (1-18)</div>
          <el-input
            type="text"
            v-model="query.businessNumber"
            placeholder="Ex: 1,2,3"
          ></el-input>
        </div>
        <div class="query-box">
          <div class="label col-12">เลขที่ใบเสร็จรับเงิน/ใบลดหนี้</div>
          <el-input type="text" v-model="query.documentNumber"></el-input>
        </div>
        <div class="query-box">
          <div class="label col-12">ข้อมูลที่ต้องการแสดง</div>
          <el-select v-model="query.status" clearable>
            <el-option
              v-for="t in filterSapStatus"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="mb-2 text-right">
        <sc-button variant="warning" @click="handleClickClear">clear</sc-button>
      </div>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSearch"
          >ค้นหา</sc-button
        >
      </div>
      <div class="report-container">
        <div class="csv">
          <button variant="secondary" @click.prevent="handleClickDownloadAsCSV">
            Download
          </button>
        </div>
        <div class="report">
          <div
            class="fi-report-row"
            :class="{ header: index === 0 }"
            v-for="(fiReport, index) in sapFiReportPresenters"
            :key="index"
          >
            <div class="report-cell receipt-link">
              <router-link
                target="_blank"
                v-if="fiReport.receipt_id"
                :to="{
                  name: 'ReceiptDetailPage',
                  params: { id: fiReport.receipt_id },
                }"
                >กดเพื่อดูใบเสร็จ</router-link
              >
            </div>
            <div class="report-cell">
              <router-link
                target="_blank"
                v-if="fiReport.appointment_id"
                :to="{
                  name: 'AppointmentDetailPage',
                  params: { id: fiReport.appointment_id },
                }"
                >กดเพื่อดูนัดหมาย</router-link
              >
            </div>
            <div class="report-cell">
              {{ fiReport.bus_no }}
            </div>
            <div class="report-cell">
              {{ fiReport.item }}
            </div>
            <div class="report-cell">
              {{ fiReport.company_code }}
            </div>
            <div class="report-cell">
              {{ fiReport.reference }}
            </div>
            <div class="report-cell">
              {{ fiReport.created_at }}
            </div>
            <div class="report-cell">
              {{ fiReport.posting_date }}
            </div>
            <div class="report-cell">
              {{ fiReport.document_date }}
            </div>
            <div class="report-cell">
              {{ fiReport.header_text }}
            </div>
            <div class="report-cell">
              {{ fiReport.cost_center }}
            </div>
            <div class="report-cell">
              {{ fiReport.assignment }}
            </div>
            <div class="report-cell">
              {{ fiReport.amount }}
            </div>
            <div class="report-cell">
              {{ fiReport.base_amount }}
            </div>
            <div class="report-cell">
              {{ fiReport.amount_vat }}
            </div>
            <div class="report-cell">
              {{ fiReport.amount_wht }}
            </div>
            <div class="report-cell">
              {{ fiReport.amount_cost }}
            </div>
            <div class="report-cell">
              {{ fiReport.reference_key_1 }}
            </div>
            <div class="report-cell">
              {{ fiReport.value_date }}
            </div>
            <div class="report-cell">
              {{ fiReport.text }}
            </div>
            <div class="report-cell">
              {{ fiReport.customer_name }}
            </div>
            <div class="report-cell">
              {{ fiReport.reference_key_2 }}
            </div>
            <div class="report-cell">
              {{ fiReport.tax_number }}
            </div>
            <div class="report-cell">
              {{ fiReport.branch_code }}
            </div>
            <div class="report-cell">
              {{ fiReport.error_message }}
            </div>
            <div class="report-cell">
              {{ fiReport.sent_to_sap }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import DatePicker from "@/lib/components/DatePicker";
import { DateTime } from "luxon";
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import ScButton from "@/lib/components/ScButton";
import { Select, Option, Input } from "element-ui";
import ProjectSelect from "@/lib/components/ProjectSelect";

export default {
  components: {
    PageWrapper,
    DatePicker,
    ScButton,
    "el-select": Select,
    "el-option": Option,
    "el-input": Input,
    ProjectSelect,
  },
  data() {
    const filterSapStatus = [
      { label: "ข้อมูลทั้งหมด", value: "" },
      { label: "ข้อมูล Success บน SAP", value: "successOnSap" },
      { label: "ข้อมูล Error บน SAP", value: "failOnSap" },
    ];

    return {
      sapFiReports: [],
      receiptDateRange: [],
      filterSapStatus,
      query: [],
      sentToSapDate: [],
      taxInvoiceDate: [],
    };
  },
  computed: {
    sapFiReportPresenters() {
      const header = {
        appointment_id: "นัดหมาย",
        receipt_id: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
        bus_no: "Bus No.",
        item: "Item",
        company_code: "Company Code",
        reference: "Reference",
        created_at: "ส่งไป SAP เมื่อ",
        posting_date: "Posting Date",
        document_date: "Document Date",
        header_text: "Header Text",
        cost_center: "Cost Center",
        assignment: "Assignment",
        amount: "Amount",
        base_amount: "Base Amount",
        amount_vat: "Amount VAT",
        amount_wht: "Amount WHT",
        amount_cost: "Amount Cost",
        reference_key_1: "Reference Key 1",
        value_date: "Value Date",
        text: "Text",
        customer_name: "Customer Name",
        reference_key_2: "Reference Key 2",
        tax_number: "Tax Number",
        branch_code: "Branch Code",
        error_message: "Error message",
        sent_to_sap: "sent to sap",
      };

      return [header, ...this.sapFiReports];
    },
    queryParams() {
      const {
        receiptDateFrom,
        receiptDateTo,
        status,
        businessNumber,
        documentNumber,
        sentToSapDateFrom,
        sentToSapDateTo,
        taxInvoiceDateFrom,
        taxInvoiceDateTo,
      } = this.$route.query;

      return {
        receiptDateFrom,
        receiptDateTo,
        status,
        businessNumber,
        documentNumber,
        sentToSapDateFrom: sentToSapDateFrom || "",
        sentToSapDateTo: sentToSapDateTo || "",
        taxInvoiceDateFrom: taxInvoiceDateFrom || "",
        taxInvoiceDateTo: taxInvoiceDateTo || "",
      };
    },
  },
  created() {
    this.setup();
  },
  watch: {
    "$route.query"() {
      this.setupData();
    },
    // receiptDateRange(newValue, oldValue) {
    //   if (!newValue) {
    //     return;
    //   }

    //   const [receiptDateFrom, receiptDateTo] = newValue;

    //   if (receiptDateTo.minus({ days: 31 }) > receiptDateFrom) {
    //     alert("ไม่สามารถเลือกเกิน 31 วันได้");
    //     this.receiptDateRange = oldValue;
    //   }
    // },
  },
  methods: {
    setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      const {
        receiptDateFrom,
        receiptDateTo,
        sentToSapDateFrom,
        sentToSapDateTo,
        taxInvoiceDateFrom,
        taxInvoiceDateTo,
      } = this.$route.query;

      if (!receiptDateFrom && !receiptDateTo) {
        return;
      }

      this.query = {
        status: this.$route.query.status || null,
        businessNumber: this.$route.query.businessNumber || null,
        documentNumber: this.$route.query.documentNumber || null,
      };
      this.receiptDateRange = [
        DateTime.fromISO(receiptDateFrom),
        DateTime.fromISO(receiptDateTo),
      ];

      if (sentToSapDateFrom && sentToSapDateTo) {
        this.sentToSapDate = [
          DateTime.fromISO(sentToSapDateFrom),
          DateTime.fromISO(sentToSapDateTo),
        ];
      }

      if (taxInvoiceDateFrom && taxInvoiceDateTo) {
        this.taxInvoiceDate = [
          DateTime.fromISO(taxInvoiceDateFrom),
          DateTime.fromISO(taxInvoiceDateTo),
        ];
      }
    },
    setupData() {
      this.setupSapFiReports();
    },
    async setupSapFiReports() {
      this.sapFiReports = await this.fetchSapFiReports();
    },
    async fetchSapFiReports() {
      const response = await baanRueJaiClient.admin.sap.getSapFiReportList(
        this.queryParams
      );

      return response.data.result;
    },
    handleClickSearch() {
      let receiptDateFrom;
      let receiptDateTo;
      if (this.receiptDateRange && this.receiptDateRange.length > 1) {
        receiptDateFrom = this.receiptDateRange[0].toISO();
        receiptDateTo = this.receiptDateRange[1].toISO();
      }

      let sentToSapDateFrom;
      let sentToSapDateTo;
      if (this.sentToSapDate && this.sentToSapDate.length > 1) {
        sentToSapDateFrom = this.sentToSapDate[0].toISO();
        sentToSapDateTo = this.sentToSapDate[1].toISO();
      }

      let taxInvoiceDateFrom;
      let taxInvoiceDateTo;
      if (this.taxInvoiceDate && this.taxInvoiceDate.length > 1) {
        taxInvoiceDateFrom = this.taxInvoiceDate[0].toISO();
        taxInvoiceDateTo = this.taxInvoiceDate[1].toISO();
      }

      const query = {
        receiptDateFrom,
        receiptDateTo,
        status: this.query.status,
        businessNumber: this.query.businessNumber,
        documentNumber: this.query.documentNumber,
        sentToSapDateFrom,
        sentToSapDateTo,
        taxInvoiceDateFrom,
        taxInvoiceDateTo,
      };
      this.$router.push({ query });
    },
    async handleClickDownloadAsCSV(event) {
      event.preventDefault();
      const response = await baanRueJaiClient.admin.sap.getSapFiReportList({
        ...this.queryParams,
        format: "xlsx",
      });

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `sap-fi-reports.xlsx`;
      link.click();
    },
    handleClickClear() {
      this.query.status = "";
      this.receiptDateRange = "";
      this.query.businessNumber = "";
      this.query.documentNumber = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.report-container {
  padding: 20px 0;
  width: 100%;
}

.fi-report-row {
  display: grid;
  grid-template-columns:
    200px
    150px
    80px
    80px
    150px
    200px
    180px
    180px
    180px
    150px
    150px
    150px
    150px
    150px
    150px
    150px
    150px
    150px
    200px
    600px
    350px
    150px
    180px
    150px
    600px
    150px;
}

.fi-report-row:first-child {
  position: sticky;
  top: 0;

  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
  }
}

.report-cell {
  padding: 10px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);
}

.report {
  padding: 15px;
}

.query-box {
  padding-right: 10px;
  padding-bottom: 10px;
  padding-top: 15px;
}

.csv {
  padding-left: 14px;
}

.receipt-link {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/features/sap/pages/SapFiReport.vue